import { useCallback, useState } from "react";
import useAdminLoad from "../../../hooks/useAdminLoad";
import * as crmApi from "../api/crmApi";

/**
 * First-run state (`GET /api/crm/setup`, contract v1.2 CR-T-14):
 * `{client_count, cards: {import: {done}, add_client: {done}, reminders: {done, sequence_id}},
 *   banner: {show, welcome_sequence_id, reminders_sequence_id}}`.
 * At zero clients the dashboard is replaced by the 3-card setup.
 */
export default function useCrmSetup() {
  const [setup, setSetup] = useState(null);
  const load = useCallback(async () => { setSetup(await crmApi.getSetup()); }, []);
  const { loading, loadError, reload } = useAdminLoad(load);

  const enableReminders = useCallback(async () => {
    await crmApi.enableReminders();
    setSetup((s) => (s ? { ...s, cards: { ...(s.cards || {}), reminders: { ...(s.cards?.reminders || {}), done: true } } } : s));
  }, []);

  const dismissBanner = useCallback(async () => {
    await crmApi.dismissSetupBanner();
    setSetup((s) => (s ? { ...s, banner: { ...(s.banner || {}), show: false } } : s));
  }, []);

  return { setup, loading, loadError, reload, enableReminders, dismissBanner };
}
